<template>
  <div class="error-message">
    <transition name="fade">
      <p class="error" v-if="error">
        {{ error }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Error',

  props: {
    error: {
      type: String
    }
  }
}
</script>

<style lang="sass">
.error-message
  height: 14px
  text-align: center

  .error
    color: red
    margin: 0
    padding: 0
    font-size: 10px
</style>
